<ion-header>
  <ion-toolbar color="primary">
    <ion-buttons slot="start">
      <ion-back-button defaultHref="/home"></ion-back-button>
    </ion-buttons>
    <ion-title>Account Settings</ion-title>
  </ion-toolbar>
</ion-header>
<ion-content color="lightmimbo">
  <ion-grid>
    <ion-row>
      <ion-col sizeXl="10" offsetXl="1">
        <ion-list class="settings-list">
          <ion-item detail routerLink="/admin" color="lightmimbo" *ngIf="isAdmin"><ion-icon name="people-circle-outline"
              class="ion-item-left ion-margin-end"></ion-icon><ion-label>Administrator</ion-label></ion-item>
          <ion-item detail routerLink="mydogs" color="lightmimbo"><ion-icon name="paw-outline"
              class="ion-item-left ion-margin-end"></ion-icon>
            <ion-label>My Pets</ion-label></ion-item>
          <ion-item detail routerLink="profile" color="lightmimbo"><ion-icon name="person-outline"
              class="ion-item-left ion-margin-end"></ion-icon><ion-label>My Profile</ion-label></ion-item>
          <ion-item detail routerLink="myposts" color="lightmimbo"><ion-icon name="image-outline"
              class="ion-item-left ion-margin-end"></ion-icon><ion-label>My Pawstagram Posts</ion-label></ion-item>
          <ion-item detail routerLink="mycases" color="lightmimbo"><ion-icon name="document-text-outline"
              class="ion-item-left ion-margin-end"></ion-icon><ion-label>My Rescue Center Cases</ion-label></ion-item>
          <ion-item detail routerLink="mycases" color="lightmimbo" [routerLink]="['/recipelist']"
            [queryParams]="{fav: 'true'}"><ion-icon name="fast-food-outline"
              class="ion-item-left ion-margin-end"></ion-icon><ion-label>Saved Recipes</ion-label></ion-item>
          <ion-item detail routerLink="change-password" color="lightmimbo"><ion-icon name="lock-closed-outline"
              class="ion-item-left ion-margin-end"></ion-icon><ion-label>Change Password</ion-label></ion-item>
          <ion-item detail routerLink="/aboutus" color="lightmimbo"><ion-icon name="happy-outline"
              class="ion-item-left ion-margin-end"></ion-icon><ion-label>About Us</ion-label></ion-item>
          <ion-item detail routerLink="contact-us" color="lightmimbo"><ion-icon name="mail-outline"
              class="ion-item-left ion-margin-end"></ion-icon><ion-label>Contact Us</ion-label></ion-item>

          <ion-item detail routerLink="/privacy-policy" color="lightmimbo"><ion-icon name="book-outline"
              class="ion-item-left ion-margin-end"></ion-icon><ion-label>Privacy Policy</ion-label></ion-item>
          <ion-item detail (click)="shareApp()" color="lightmimbo" button="true">
            <ion-icon name="share-social-outline" class="ion-item-left ion-margin-end"></ion-icon><ion-label>Share With
              Friends</ion-label>
          </ion-item>
        </ion-list>
      </ion-col>
    </ion-row>
  </ion-grid>

  <ion-grid>
    <ion-row>
      <ion-col sizeMd="4" offsetMd="4">
        <ion-button color="danger" expand="full" (click)="confirmLogout()"><ion-icon name="log-out-outline"
            slot="start"></ion-icon>Log
          Out</ion-button>
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col sizeMd="4" offsetMd="4">
        <ion-button color="danger" expand="full" routerLink="deactivate"><ion-icon name="trash-outline"
            slot="start"></ion-icon> Delete
          Account</ion-button>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>